import merge from 'lodash.merge';
import getUser from './user.js';

export default async (data, conf = {}, digestUser) => {
    const isPageTrack = data.event === 'trackPage';

    if (isPageTrack) {
        const user = await getUser(conf);
        data.user = merge(data.user, digestUser ? digestUser(user) : user);
        const referringURL = data?.page?.pageInfo?.referringURL;
        const hostName = document?.location?.host;
        const referrerType = referringURL?.indexOf(hostName) < 0 ? 'External' : 'Internal';

        window.yos = {
            mPulseVariables: {
                pageGroup: data?.page?.category?.pageType,
                abTest: '', //we can add it later, when our new Optimizely flag have been setup
                referrerType: referrerType,
                deviceMemory: (navigator.deviceMemory || -1).toFixed(), //we only can get this for Chrome and Firefox, Safari will be -1
            },
        };
    }
    
    window.dataLayer = window.dataLayer || [];

    if (isPageTrack) {
      window.dataLayer.push(data);
      if (window.queuedDataLayer) {
        window.dataLayer.push(...window.queuedDataLayer);
        delete window.queuedDataLayer;
      }
    } else {
      if (window.queuedDataLayer) {
        window.queuedDataLayer.push(data);
      } else {
        window.dataLayer.push(data);
      }
    }
};
